/**
 * Chiede al service worker di prefetchare le tile mappa (produzione / SW attivo).
 * @param {[number,number,number,number]} bbox minLon, minLat, maxLon, maxLat
 * @param {[number,number]} zoomRange minZoom, maxZoom
 * @param {(downloaded: number, total: number) => void} [onProgress]
 * @returns {Promise<{ downloaded: number, total: number, failed: number }>}
 */
export function postPrefetchTilesMessage(bbox, zoomRange = [10, 14], onProgress) {
  if (typeof navigator === 'undefined' || !navigator.serviceWorker?.controller) {




    return Promise.resolve({ downloaded: 0, total: 0, failed: 0 });
  }



  return new Promise((resolve) => {
    const channel = new MessageChannel();
    const timeout = window.setTimeout(() => {

      resolve({ downloaded: 0, total: 0, failed: 0 });
    }, 60 * 1000);

    channel.port1.onmessage = (event) => {
      const d = event.data;
      if (!d || typeof d !== 'object') return;

      if (d.type === 'PREFETCH_PROGRESS' && typeof d.total === 'number') {
        const processed = typeof d.processed === 'number' ? d.processed : d.downloaded;
        if (typeof processed === 'number') onProgress?.(processed, d.total);
        return;
      }

      if (d.type === 'PREFETCH_TILES_DONE' || d.type === 'PREFETCH_COMPLETE') {
        window.clearTimeout(timeout);
        const out = {
          downloaded: typeof d.downloaded === 'number' ? d.downloaded : 0,
          total: typeof d.total === 'number' ? d.total : 0,
          failed: typeof d.failed === 'number' ? d.failed : 0
        };

        resolve(out);
      }
    };

    navigator.serviceWorker.controller.postMessage(
      {
        type: 'PREFETCH_TILES',
        bbox,
        zoomRange
      },
      [channel.port2]
    );
  });
}